<template>
  <div class="card">
    <div class="card-header">
      <h4 class="title" style="text-align: center;">Current Plan</h4>
    </div>
    <div class="card-content" style="text-align: center;">
      <h5>{{ authDetails.account.data.planName }}<br>
      <small>${{ authDetails.account.data.planPrice }} {{ authDetails.account.data.planInterval }}</small>
      </h5>
      <button class="btn btn-sm" @click.prevent="goChangePlan()">Change Plan</button>
    </div>
    <hr>
    <div class="text-center">
      <div class="row">
        <div>Plan Limits</div>
        <div class="col-xs-3">
          <h5>{{ authDetails.account.data.planConstraints.maxCodesPerMonth }}
            <br>
            <small>Codes/Month</small>
          </h5>
        </div>
        <div class="col-xs-3">
          <h5>{{ authDetails.account.data.planConstraints.maxCustomRetailers }}
            <br>
            <small>Retailers</small>
          </h5>
        </div>
        <div class="col-xs-3">
          <h5>{{ authDetails.account.data.planConstraints.maxUsers }}
            <br>
            <small>Users</small>
          </h5>
        </div>
        <div class="col-xs-3">
          <h5>{{ authDetails.account.data.planConstraints.maxBrands }}
            <br>
            <small>Brands</small>
          </h5>
        </div>
      </div>
    </div>
    <hr>
    <div class="text-center">
      <div class="row">
        <div>Plan Usage for {{ thisMonth }} {{ thisYear }}</div>
        <div class="col-xs-3">
          <h5>{{ authDetails.account.data.planUsageQtyCodesThisMonth }}
            <br>
            <small>Codes</small>
          </h5>
        </div>
        <div class="col-xs-3">
          <h5>{{ authDetails.account.data.planUsageQtyCustomRetailers }}
            <br>
            <small>Retailers</small>
          </h5>
        </div>
        <div class="col-xs-3">
          <h5>{{ authDetails.account.data.planUsageQtyUsers }}
            <br>
            <small>Users</small>
          </h5>
        </div>
        <div class="col-xs-3">
          <h5>{{ authDetails.account.data.planUsageQtyBrands }}
            <br>
            <small>Brands</small>
          </h5>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import moment from 'moment'
  import { toolboxMixin } from '@/components/mixins/toolboxMixin'

  export default {
    props: {
      authDetails: {
        type: Object,
        required: true
      }
    },
    mixins: [toolboxMixin],
    computed: {
      thisMonth () {
        return moment().format('MMMM')
      },
      thisYear () {
        return moment().format('YYYY')
      },
      planUsageQtyCodesThisMonth () {
        if (!this.authDetails.account.data.lastBatchCreatedAt) return 0
        let lastBatchCreatedAt = this.authDetails.account.data.lastBatchCreatedAt.toDate()
        // if not the same month... ie it's next month and no codes have been made yet
        if (!moment().isSame(lastBatchCreatedAt, 'year') || !moment().isSame(lastBatchCreatedAt, 'month')) return 0
        let remaining = this.authDetails.account.data.planConstraints.maxCodesPerMonth - this.authDetails.account.data.planUsageQtyCodesThisMonth
        remaining = Math.max(remaining, 0)
        return remaining
      }
    },
    methods: {
      goChangePlan () {
        this.$router.replace({ name: 'Change Plan' })
      }
    },
    mounted: function () {
      this.$nextTick(function () {
        console.log('authDetails in plan details card', this.authDetails)
      })
    }
  }

</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Account/partials/PlanDetails.vue